import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL, WHATSAPP_NUMBER_DISPLAY } from "../lib/whatsapp";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[rgba(201,162,75,0.22)] bg-[#0a0a09]"
    >
      <div className="mx-auto max-w-6xl px-5 py-12 sm:px-8">
        <div className="flex flex-col justify-between gap-8 sm:flex-row sm:items-start">
          <p className="max-w-sm text-sm leading-relaxed text-[#a09a8c]">
            Driving test booking support and insurance claim assistance across
            the UK.
          </p>

          <div className="flex flex-col gap-3 text-sm">
            <Link
              to="/"
              data-testid="footer-home-link"
              className="text-[#a09a8c] transition-colors duration-200 hover:text-[#f2ede3]"
            >
              Home
            </Link>
            <Link
              to="/driving-tests"
              data-testid="footer-driving-tests-link"
              className="text-[#a09a8c] transition-colors duration-200 hover:text-[#f2ede3]"
            >
              Driving Tests
            </Link>
            <Link
              to="/claims"
              data-testid="footer-claims-link"
              className="text-[#a09a8c] transition-colors duration-200 hover:text-[#f2ede3]"
            >
              Motor Claims Assist
            </Link>
            <Link
              to="/reviews"
              data-testid="footer-reviews-link"
              className="text-[#a09a8c] transition-colors duration-200 hover:text-[#f2ede3]"
            >
              Reviews &amp; Testimonials
            </Link>
            <Link
              to="/faq-contact"
              data-testid="footer-faq-contact-link"
              className="text-[#a09a8c] transition-colors duration-200 hover:text-[#f2ede3]"
            >
              FAQ &amp; Contact
            </Link>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="inline-flex items-center gap-2 text-[#e6c87a] transition-colors duration-200 hover:text-[#f2ede3]"
            >
              <MessageCircle size={15} />
              WhatsApp: {WHATSAPP_NUMBER_DISPLAY}
            </a>
          </div>
        </div>

        <div className="gold-line mt-10" />
        <p className="mt-6 text-xs tracking-wide text-[#6f6a5f]">
          © {new Date().getFullYear()} EDT Solutions &amp; Services UK. All
          rights reserved.
        </p>
      </div>
    </footer>
  );
};
